import { render } from "./TrfPhoneInput.vue?vue&type=template&id=a9c848c2&scoped=true"
import script from "./TrfPhoneInput.vue?vue&type=script&lang=js"
export * from "./TrfPhoneInput.vue?vue&type=script&lang=js"

import "./TrfPhoneInput.vue?vue&type=style&index=0&id=a9c848c2&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9c848c2"],['__file',"src/components/Input/TrfPhoneInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9c848c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9c848c2', __exports__)) {
    console.log('reload')
    api.reload('a9c848c2', __exports__)
  }
  
  module.hot.accept("./TrfPhoneInput.vue?vue&type=template&id=a9c848c2&scoped=true", () => {
    console.log('re-render')
    api.rerender('a9c848c2', render)
  })

}


export default __exports__